import { render, staticRenderFns } from "./ComunityView.vue?vue&type=template&id=3dae0abb&scoped=true"
import script from "./ComunityView.vue?vue&type=script&lang=js"
export * from "./ComunityView.vue?vue&type=script&lang=js"
import style0 from "./ComunityView.vue?vue&type=style&index=0&id=3dae0abb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae0abb",
  null
  
)

export default component.exports